export default {"src":"/_next/static/media/generic-thumbnail-doc.a87da443.svg","height":92,"width":66,"blurWidth":0,"blurHeight":0};